/**
 * NIGHTBOUND - client entry point.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

const container = document.getElementById('root')
if (!container) throw new Error('NIGHTBOUND: #root element is missing from index.html.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// The boot message is removed after the first paint; if React failed to mount
// for any reason, the message stays rather than leaving a blank page.
requestAnimationFrame(() => {
  if (container.childElementCount > 0) {
    document.getElementById('nightbound-boot')?.remove()
  }
})
